export default "__VITE_ASSET__B$gGDk8T__"